import React from 'react';
import styles from './css/ArticlesCTA.styl';
import CTABlock from '../CTABlock';
import appConfig from '../../../../../appConfig/AppConfig';

const niceBreakingBlurb = (
  <span>
    We have resources to help you through every stage of funeral planning,{' '}
    <span style={{whiteSpace: 'nowrap'}}>grieving and remembrance.</span>
  </span>
);
const data = {
  title: 'Feeling Overwhelmed?',
  blurb: niceBreakingBlurb,
  button: {
    text: 'View Helpful Articles',
    href: `${appConfig().vanityDomain}/news/advice-and-support`,
  },
};

const ArticlesCTA = () => (
  <div className={styles.ArticlesCTA}>
    <CTABlock
      blurb={data.blurb}
      button={data.button}
      className="LongBlurb"
      title={data.title}
      newWindow
    />
  </div>
);

export default ArticlesCTA;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Planning/components/ArticlesCTA/index.js